import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { motion } from 'framer-motion';
import React from 'react';

var CollapseRaw = function CollapseRaw(_ref) {
  var isExpand = _ref.isExpand,
      renderExpand = _ref.renderExpand,
      bodyItem = _ref.bodyItem;
  if (!renderExpand) return null;
  return _jsx(Container, {
    initial: "collapsed",
    animate: isExpand ? 'open' : 'collapsed',
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: 'auto',
        overflow: 'auto'
      },
      collapsed: {
        opacity: 0,
        height: 0,
        overflow: 'hidden'
      }
    },
    transition: {
      duration: 0.5
    },
    children: renderExpand(bodyItem, isExpand) || null
  }, "collapsed");
};

export var Collapse = /*#__PURE__*/React.memo(CollapseRaw);

var Container = /*#__PURE__*/_styled(motion.div, true ? {
  target: "ea8phdt0"
} : {
  target: "ea8phdt0",
  label: "Container"
})(true ? {
  name: "1h113tv",
  styles: "grid-area:collapse;::-webkit-scrollbar{display:none;}"
} : {
  name: "1h113tv",
  styles: "grid-area:collapse;::-webkit-scrollbar{display:none;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvYXBwcy9mcm9udGVuZC9zcmMvY29tcG9uZW50cy9OZXdUYWJsZS9jb21wb25lbnRzL1Jvd0l0ZW0vY29tcG9uZW50cy9Db2xsYXBzZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEJvQyIsImZpbGUiOiIvdmVyY2VsL3BhdGgwL2FwcHMvZnJvbnRlbmQvc3JjL2NvbXBvbmVudHMvTmV3VGFibGUvY29tcG9uZW50cy9Sb3dJdGVtL2NvbXBvbmVudHMvQ29sbGFwc2UudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBtb3Rpb24gfSBmcm9tICdmcmFtZXItbW90aW9uJ1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuXG50eXBlIFByb3BzID0ge1xuICBpc0V4cGFuZDogYm9vbGVhblxuICByZW5kZXJFeHBhbmQ/OiBhbnlcbiAgYm9keUl0ZW0/OiBhbnlcbn1cbmNvbnN0IENvbGxhcHNlUmF3OiBSZWFjdC5GQzxQcm9wcz4gPSAoeyBpc0V4cGFuZCwgcmVuZGVyRXhwYW5kLCBib2R5SXRlbSB9KSA9PiB7XG4gIGlmICghcmVuZGVyRXhwYW5kKSByZXR1cm4gbnVsbFxuICByZXR1cm4gKFxuICAgIDxDb250YWluZXJcbiAgICAgIGtleT1cImNvbGxhcHNlZFwiXG4gICAgICBpbml0aWFsPVwiY29sbGFwc2VkXCJcbiAgICAgIGFuaW1hdGU9e2lzRXhwYW5kID8gJ29wZW4nIDogJ2NvbGxhcHNlZCd9XG4gICAgICBleGl0PVwiY29sbGFwc2VkXCJcbiAgICAgIHZhcmlhbnRzPXt7XG4gICAgICAgIG9wZW46IHsgb3BhY2l0eTogMSwgaGVpZ2h0OiAnYXV0bycsIG92ZXJmbG93OiAnYXV0bycgfSxcbiAgICAgICAgY29sbGFwc2VkOiB7IG9wYWNpdHk6IDAsIGhlaWdodDogMCwgb3ZlcmZsb3c6ICdoaWRkZW4nIH1cbiAgICAgIH19XG4gICAgICB0cmFuc2l0aW9uPXt7IGR1cmF0aW9uOiAwLjUgfX1cbiAgICA+XG4gICAgICB7cmVuZGVyRXhwYW5kKGJvZHlJdGVtLCBpc0V4cGFuZCkgfHwgbnVsbH1cbiAgICA8L0NvbnRhaW5lcj5cbiAgKVxufVxuXG5leHBvcnQgY29uc3QgQ29sbGFwc2UgPSBSZWFjdC5tZW1vKENvbGxhcHNlUmF3KVxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQobW90aW9uLmRpdilgXG4gIGdyaWQtYXJlYTogY29sbGFwc2U7XG4gIDo6LXdlYmtpdC1zY3JvbGxiYXIge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbmBcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});